import React from 'react';

type Props = {
  width: number;
  height: number;
  fill?: string;
}

const DistributionEngineIcon = ({
  width, height, fill,
}: Props) => (
  <svg width={width} height={height} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4.93738 2.90115L10.9667 2.90115L13.9882 8.18045L10.9667 13.4597L4.93738 13.4597L1.91492 8.18045L4.93738 2.90115Z" stroke="#9D174D" strokeWidth="1.6" />
    <circle cx="13.7968" cy="8.18026" r="1.51681" fill="white" stroke="#9D174D" strokeWidth="0.96" />
    <circle cx="7.95214" cy="8.18026" r="1.63174" fill="white" stroke="#9D174D" strokeWidth="0.730141" />
    <circle cx="11.1575" cy="2.99681" r="1.51681" fill="white" stroke="#9D174D" strokeWidth="0.96" />
    <circle cx="4.99462" cy="2.99681" r="1.51681" fill="white" stroke="#9D174D" strokeWidth="0.96" />
    <circle cx="2.19683" cy="8.18026" r="1.51681" fill="white" stroke="#9D174D" strokeWidth="0.96" />
    <circle cx="4.99462" cy="12.7968" r="1.51681" fill="white" stroke="#9D174D" strokeWidth="0.96" />
    <circle cx="11.1575" cy="12.7968" r="1.51681" fill="white" stroke="#9D174D" strokeWidth="0.96" />
  </svg>

);

DistributionEngineIcon.defaultProps = {
  fill: 'var(--distributionEngineColor)',
};

export default DistributionEngineIcon;
